module.exports = __webpack_public_path__ + "media/images/version_merge/why_clock-f3f417a1577a2ee7b2e464990ec84fbf.svg";